import vibeCover from "./img/releases/vibe_cover.jpg";
import seeleCover from "./img/releases/seele_cover.png";
import poisonCover from "./img/releases/poison_cover.jpg"
import straassCover from "./img/releases/strass_cover.jpg"

export const BANDS_IN_TOWN_APP_ID = "01d637208fbf5f3be242f58ab29268be"

export const LINKTREE_LINKS = [
    {
        label: "Website",
        url: "/"
    },
    {
        label: "Seele on Spotify!",
        url: "https://open.spotify.com/track/5Fj0wKiFEU6sdkENsDqwAx?si=a749ef93e87b41c0"
    },
    {
        label: "Seele on Apple Music!",
        url: "https://music.apple.com/us/album/seele/1769566342"
    },
    {
        label: "Shows",
        url: "https://www.bandsintown.com/a/15505028-entropy-hill"
    },
    {
        label: "Instagram",
        url: "https://www.instagram.com/entropy_hill/"
    },
    {
        label: "Facebook",
        url: "https://www.facebook.com/entropyhillband/"
    },
    {
        label: "MX3",
        url: "https://mx3.ch/entropyhill/"
    },
]

export const MUSIC_ENTRIES = [
    {
        title: "Vibe",
        coverImage: vibeCover,
        musicFile: "https://entropyhill.com/media/audio/vibe.mp3",
        links: {
            spotifyEmbedded: "https://open.spotify.com/embed/track/3Cynv63p3EfKlcySoUp64r",
            spotify: "https://open.spotify.com/track/3Cynv63p3EfKlcySoUp64r",
            apple: "https://music.apple.com/us/album/vibe-single/1713030118",
            soundcloud: "https://soundcloud.com/entropy-hill/vibe",
            deezer: "https://deezer.page.link/WYovjzhzaZvvZaxw6",
            tidal: ""
        },
        releaseDate: new Date(2023, 9, 27)
    },
    {
        title: "Seele",
        coverImage: seeleCover,
        musicFile: "https://entropyhill.com/media/audio/seele.mp3",
        links: {
            spotifyEmbedded: "https://open.spotify.com/embed/track/5Fj0wKiFEU6sdkENsDqwAx",
            spotify: "https://open.spotify.com/track/5Fj0wKiFEU6sdkENsDqwAx?si=a749ef93e87b41c0",
            apple: "https://music.apple.com/us/album/seele/1769566342",
            soundcloud: "https://soundcloud.com/entropy-hill/seele",
            deezer: "https://deezer.page.link/TKbJ2KX9mhZj8SaK9",
            tidal: ""
        },
        releaseDate: new Date(2024, 9, 11)
    },
    {
        title: "Poison",
        coverImage: poisonCover,
        musicFile: "https://entropyhill.com/media/audio/poison.mp3",
        links: {
            spotifyEmbedded: "https://open.spotify.com/embed/track/5XjWVXIP0qVErtZVRZWOuf",
            spotify: "https://open.spotify.com/track/5XjWVXIP0qVErtZVRZWOuf?si=a36a1441d11444fe",
            apple: "https://music.apple.com/au/album/poison/1775115603?i=1775115604",
            soundcloud: "https://soundcloud.com/entropy-hill/poison",
            deezer: "",
            tidal: ""
        },
        releaseDate: new Date(2024, 10, 1)
    },
    {
        title: "Straass (Acoustic Version)",
        coverImage: straassCover,
        musicFile: "https://entropyhill.com/media/audio/straass.mp3",
        links: {
            spotifyEmbedded: "https://open.spotify.com/embed/track/7qLuxVGkMX6HwHabFlkQ6p",
            spotify: "https://open.spotify.com/track/7qLuxVGkMX6HwHabFlkQ6p?si=3945ccf2c8c64f62",
            apple: "https://music.apple.com/us/album/straass-acoustic-version/1782639463?i=1782639464",
            soundcloud: "https://soundcloud.com/entropy-hill/straass-acoustic-verison",
            deezer: "",
            tidal: ""
        },
        releaseDate: new Date(2024, 11, 6)
    },
]

export const SOCIAL_MEDIA_ACCOUNTS = [
    {
        network: "",
        url: "https://www.instagram.com/entropy_hill",
    },
    {
        network: "",
        url: "https://www.facebook.com/entropyhillband/",
    },
    {
        network: "",
        url: "https://open.spotify.com/artist/4APfaKKTUYeoETKFP4HCTy",
    },
    {
        network: "itunes",
        url: "https://music.apple.com/artist/1713019741",
    },
    {
        network: "",
        url: "https://www.bandsintown.com/a/15505028-entropy-hill",
    },
    {
        network: "",
        url: "mailto:booking@entropyhill.com",
    },
]